/**
 * RCP portal entry point.
 * Loads styles + renders the <App/> tree into #root.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { urlHasAuthResponse, runMsalRedirectBridge } from './services/msalRedirectBridge';

import '@flaticon/flaticon-uicons/css/regular/rounded.css';
import './styles/tokens.css';
import './styles/globals.css';
import './styles/layout.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found in index.html');

const startApp = (): void => {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
};

// MSAL v5: when this page load is the sign-in return (popup, hidden iframe or full-page redirect),
// hand the response to MSAL instead of starting the app here. See msalRedirectBridge.ts.
if (urlHasAuthResponse()) {
  void runMsalRedirectBridge().then((handled) => {
    if (!handled) startApp();
  });
} else {
  startApp();
}
